import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_bxk4vc4629: FaireCollectionEntity = {
  token: "pbc_bxk4vc4629",
  type: "collection",
  name: "Dinosaur Organic Baby Clothing Collection",
  heroImageUrl:
    "https://cdn.faire.com/fastly/63a41feb8ff01bf8e21c1b95fd37c5207db6a38e98ca0baf1e8f9ade52be5293.jpeg",
  itemCount: 30,
  description:
    "Made from small-farmer grown organic cotton and ethically crafted in India, these soft, breathable essentials feature playful dinosaur prints that parents and gift-givers love.",
  brandToken: "b_7fghelgl",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T04:59:20.716Z",
    importedBy: "entity-db-import-collections",
  },
};
